import { Card, FormGroup, Switch } from '@ksyos/design-system';
import type { IOrganization } from '@frontend/components/interfaces/organization';
import type { ValidationErrors } from '@frontend/utils/validation';
import { getSelectedLanguage } from '@frontend/translate';

type KsyosAccountCardProps = {
    errors: ValidationErrors;
    handleChange: <K extends keyof IOrganization>(name: K, value: IOrganization[K]) => void;
    organization: IOrganization;
};

export function KsyosAccountCard({ errors, handleChange, organization }: KsyosAccountCardProps) {
    const translate = getSelectedLanguage();

    return (
        <Card>
            <Card.Header title={translate.profile.ksyosAccount} />
            <Card.Body>
                <FormGroup
                    hasErrors={errors.has('isHighPrivacy')}
                    label={translate.organization.highPrivacyLevel}
                    tooltipText={translate.organization.highPrivacyLevelTooltip}
                >
                    <Switch
                        ariaLabel="checkbox"
                        checked={!!organization.isHighPrivacy}
                        onChange={(e) => handleChange('isHighPrivacy', e.target.checked)}
                    />
                </FormGroup>
                <FormGroup
                    hasErrors={errors.has('isMijnKsyosActive')}
                    label={translate.organization.isMijnKsyosActive}
                    tooltipText={translate.organization.isMijnKsyosActiveTooltip}
                >
                    <Switch
                        ariaLabel="checkbox"
                        checked={!!organization.isMijnKsyosActive}
                        onChange={(e) => handleChange('isMijnKsyosActive', e.target.checked)}
                    />
                </FormGroup>
            </Card.Body>
        </Card>
    );
}
